import { gql } from '@apollo/client'

export const Query = gql`
  query EditTaxRate($companyId: ID!, $filters: TaxRateFilters) {
    taxRates(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        rate
      }
    }
  }
`
